export const HOME = {
    nav: "site-nav",
    navLogo: "nav-logo",
    navStory: "nav-link-story",
    navGallery: "nav-link-gallery",
    navRequirements: "nav-link-requirements",
    navContact: "nav-link-contact",
    navCta: "nav-cta-contact",
    heroPrimaryCta: "hero-primary-cta",
    heroSecondaryCta: "hero-secondary-cta",
    storySection: "section-story",
    gallerySection: "section-gallery",
    requirementsSection: "section-requirements",
    contactSection: "section-contact",
    contactKimPhone: "contact-kim-phone",
    contactArturoPhone: "contact-arturo-phone",
    contactEmail: "contact-email",
    contactForm: "contact-form",
    contactName: "contact-input-name",
    contactEmailInput: "contact-input-email",
    contactPhoneInput: "contact-input-phone",
    contactMessage: "contact-input-message",
    contactSubmit: "contact-submit-button",
    contactSuccess: "contact-success-message",
    contactError: "contact-error-message",
    footer: "site-footer",
};
